import React from 'react';

// https://newwaysecurity.com/static/media/logo.ca8859054599731150cc.jpeg

const Data = [
    {
        image: "https://www.spaceinternationals.in/static/media/logo.f968b121361e7a4c2250.png"
    },
    {
        image: "https://avistore.in/admin/assets/img/logo.png"
    },
    {
        image: "https://www.lakmeindia.com/cdn/shop/files/Lkm1_1_47aec8f4-69ca-4d80-be5f-b941bc1bf140_155x.png?v=1696105515"
    },
    {
        image: "https://jagritikhurana.com/images/main/jagriti.png"
    },
    {
        image: "/images/brand/brand-6.png"
    },
    {
        image: "https://scontent.cdninstagram.com/v/t51.2885-19/431218797_423993436763725_3815662516912129470_n.jpg?stp=cp0_dst-jpg_s110x80_tt6&_nc_cat=100&ccb=1-7&_nc_sid=bf7eb4&_nc_ohc=Ldm1I-qaK2gQ7kNvgGOBJKu&_nc_zt=24&_nc_ht=scontent.cdninstagram.com&oh=00_AYAk6f6tKpwMyp2fjRLdhIn_FbND-Fw17GUTiyzZx2mBvg&oe=6777ABC1"
    },
    {
        image: "https://codingeggs.vercel.app/static/media/Logo.cb61554509778ab9c141.png"
    }
]


const BrandItem = () => {
    return (
        <>
            {Data.map((data, index) => (
                <div className="col-lg-3 col-6" key={index}>
                    <div className="brand-grid">
                        <img src={process.env.PUBLIC_URL + data.image} alt="Brand" />
                    </div>
                </div>
            ))}
        </>
    )
}

export default BrandItem;